/**
 * Вид выключенной главной кнопки — одна дверь для стиль-пака
 * (`StylePackCta.disabledStyle`) и для своего поля воронки `settings.quizCta`
 * (слово владельца 21.10.2026, components/quiz-runtime/quizCta.ts).
 *
 * Настоящего disabled у кнопки «Далее» нет (валидация — подсказка по клику,
 * WEB-895): пока на экране есть незаполненные обязательные блоки, кнопка несёт
 * класс `.funnel-next-unfilled` (public-paywall.css), а он читает две
 * переменные — их значения считаются здесь (WEB-922):
 *  - `muted-brand` — только прозрачность (бренд остаётся, 12min);
 *  - `grey` — прозрачность и обесцвечивание;
 *  - `muted-brand-dark` (эталон Slimkit) — прозрачность 0.5; затемнение 15 %
 *    кладёт ctaPackButtonStyle (quiz-runtime/ctaDockStyle.ts) внутренней тенью.
 *
 * Перечень сверяет со схемой сервера сторож quiz-cta.ends.spec.ts.
 */
export const CTA_DISABLED_STYLES = [
  'muted-brand',
  'grey',
  'muted-brand-dark',
] as const;

export type CtaDisabledStyle = (typeof CTA_DISABLED_STYLES)[number];

const STYLE_OPACITY: Record<CtaDisabledStyle, string> = {
  'muted-brand': '0.45',
  grey: '0.55',
  'muted-brand-dark': '0.5',
};

export interface CtaDisabledVars {
  '--next-disabled-opacity': string;
  '--next-disabled-filter': string;
}

/**
 * Переменные приглушения. `opacity` (своё поле воронки) сильнее прозрачности
 * вида; обесцвечивание — только у `grey`. Вида нет (воронка без пака) —
 * прозрачность своя или 1 (прежний вид без пака: кнопка не тускнеет).
 */
export function ctaDisabledVars(
  style: CtaDisabledStyle | undefined,
  opacity?: number,
): CtaDisabledVars {
  return {
    '--next-disabled-opacity':
      opacity !== undefined
        ? String(opacity)
        : style
          ? STYLE_OPACITY[style]
          : '1',
    '--next-disabled-filter': style === 'grey' ? 'grayscale(1)' : 'none',
  };
}
